import axios from 'axios'

const MELI_CITIES_ENDPOINT = "https://api.mercadolibre.com/classified_locations/states"

export default async function getCities (province_Id) {
    const response = await axios.get(`${MELI_CITIES_ENDPOINT}/${province_Id}`)
    if (response.status === 200) {
        return response.data.cities
    }
    return null

}